<template>
  <div>
    <label
      class="inline-flex items-start gap-2 cursor-pointer select-none"
      :class="{ 'opacity-60 !cursor-not-allowed': _disabled }"
    >
      <input
        v-model="checkBoxValue"
        type="checkbox"
        class="peer sr-only"
        :disabled="_disabled"
      />
      <span
        class="flex h-5 w-5 flex-none items-center justify-center rounded border-2 transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-primary-lighter"
        :class="checkBoxValue ? boxColorClasses : 'border-gray-400 bg-white'"
      >
        <IconComponent
          v-show="checkBoxValue"
          icon="check"
          class="w-3 h-3 text-white"
        />
        <div v-show="!checkBoxValue" class="w-3 h-3" />
      </span>
      <span class="leading-5">
        <slot name="label">
          <slot>
            <span v-if="label">{{ label }}</span>
          </slot>
        </slot>
      </span>
    </label>
    <p v-if="failed" class="text-sm text-error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { inject } from "@nuxtjs/composition-api";

export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      required: true,
    },
    validationState: {
      type: Object,
      required: false,
      default: () => {},
    },
    type: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { disabled: formDisabled } = inject("form", { disabled: false });
    return {
      formDisabled,
    };
  },
  computed: {
    _disabled() {
      return this.disabled || this.formDisabled;
    },
    errorMessage() {
      return this.validationState?.$errors?.[0]?.$message;
    },
    failed() {
      return this.validationState?.$error;
    },
    boxColorClasses() {
      // danger/error both map to red to preserve the previous danger (red) look
      if (this.failed || this.type === "danger" || this.type === "error") {
        return "bg-error border-error";
      }
      switch (this.type) {
        case "success":
          return "bg-success border-success";
        case "info":
          return "bg-info border-info";
        case "warning":
          return "bg-warning border-warning";
        default:
          return "bg-primary border-primary";
      }
    },
    checkBoxValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
